import { jsx as _jsx } from "react/jsx-runtime";
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
export const Drop = ({ children, greedy = false, onDrop }) => {
    const [drop, dropRef] = useDrop({
        accept: [NativeTypes.FILE],
        collect: (monitor) => ({
            isHover: monitor.isOver({ shallow: true }),
        }),
        drop: (droppedFiles, monitor) => {
            const didDrop = monitor.didDrop();
            if (didDrop && !greedy) {
                return;
            }
            return onDrop(droppedFiles);
        },
    });
    return _jsx("div", { ref: dropRef, children: children({ isHover: drop.isHover }) });
};
//# sourceMappingURL=Drop.js.map